import React from "react";
import PropTypes from "prop-types";
import { Table } from "components";
import { UnderwritingService } from "services";
import { Map, List } from "immutable";
import { Statistic, Row, Col, Card, Slider } from "antd";
import {
    LedgerAnalysisRecord,
    LedgerAnalysisSummaryRecord
} from "records/supply-chain-record";

import { LEDGER_ANALYSIS_COLS } from "constants/table-columns";

class LedgerAnalysis extends React.Component {
    state = {
        count: 0,
        analysis: new Map({
            list: new Map({}),
            1: new List([])
        }),
        loading: false,
        currentPage: "1",
        pageSize: "500",
        summaryRecord: new LedgerAnalysisSummaryRecord({}),
        minimumLimit: 0,
        minimumVintage: 0
    };

    componentDidMount() {
        this.setState(
            {
                loading: true
            },
            () => {
                UnderwritingService.getLedgerAnalysisSummary(
                    this.props.match.params.id
                ).then(({ data, error }) => {
                    if (!error) {
                        this.setState({
                            minimumLimit: Number(data.minimum_limit),
                            minimumVintage: Number(data.minimum_vintage),
                            summaryRecord: new LedgerAnalysisSummaryRecord({
                                ...data
                            })
                        });
                    }
                });

                UnderwritingService.getLedgerAnalysis(
                    this.props.match.params.id,
                    this.state.currentPage,
                    this.state.pageSize
                ).then(({ data, error }) => {
                    if (error) {
                        this.setState({
                            loading: false
                        });
                        return;
                    }
                    const { analysis } = this.state;
                    const newAnalysis = new List(data.results).map(
                        _ => new LedgerAnalysisRecord(_)
                    );
                    this.setState({
                        count: data.count,
                        analysis: analysis
                            .set(
                                String(this.state.currentPage),
                                new List(newAnalysis)
                            ),
                        loading: false
                    });
                });
            }
        );
    }

    onPageChange = (page, pageSize) => {
        if (
            this.state.analysis.get(String(page)) &&
            this.state.analysis.get(String(page)).size === Number(pageSize)
        ) {
            this.setState({
                currentPage: String(page),
                pageSize: String(pageSize)
            });
        } else {
            this.setState(
                {
                    currentPage: String(page),
                    pageSize: String(pageSize),
                    loading: true,
                    analysis: this.state.analysis.set(
                        String(page),
                        new List([])
                    )
                },
                () =>
                    UnderwritingService.getLedgerAnalysis(
                        this.props.match.params.id,
                        this.state.currentPage,
                        this.state.pageSize
                    ).then(({ data, error }) => {
                        if (error) {
                            this.setState({
                                loading: false
                            });
                            return;
                        }
                        const { analysis } = this.state;
                        const newAnalysis = new List(data.results).map(
                            _ => new LedgerAnalysisRecord(_)
                        );
                        this.setState({
                            count: data.count,
                            analysis: analysis
                                .set(
                                    String(this.state.currentPage),
                                    new List(newAnalysis)
                                ),
                            loading: false
                        });
                    })
            );
        }
    };

    onFilterChange = (key, value) => {
        this.setState(
            {
                [key]: value,
                loading: true
            },
            () => {
                UnderwritingService.getLedgerAnalysisSummary(
                    this.props.match.params.id,
                    this.state.minimumVintage,
                    this.state.minimumLimit
                ).then(({ data, error }) => {
                    if (!error) {
                        this.setState({
                            summaryRecord: new LedgerAnalysisSummaryRecord({
                                ...data
                            })
                        });
                    }
                });
                UnderwritingService.getLedgerAnalysis(
                    this.props.match.params.id,
                    this.state.currentPage,
                    this.state.pageSize,
                    this.state.minimumVintage,
                    this.state.minimumLimit
                ).then(({ data, error }) => {
                    if (error) {
                        this.setState({
                            loading: false
                        });
                        return;
                    }
                    const { analysis } = this.state;
                    const newAnalysis = new List(data.results).map(
                        _ => new LedgerAnalysisRecord(_)
                    );
                    this.setState({
                        count: data.count,
                        analysis: analysis
                            // .mergeIn(
                            //     ["list"],
                            //     newAnalysis
                            //         .toMap()
                            //         .mapEntries(([, v]) => [v.id, v])
                            // )
                            .set(
                                String(this.state.currentPage),
                                new List(newAnalysis)
                            ),
                        loading: false
                    });
                });
            });
    };

    render() {
        return (
            <Row className={"p-5"}>
                <Col span={18} className={"p-5"}>
                    <Card loading={this.state.loading}>
                        <div className={"d-flex flex-wrap p-5"}>
                            {this.state.summaryRecord.summaryList
                                .map((v, k) => (
                                    <Statistic
                                        key={k}
                                        title={k}
                                        value={v}
                                        className={"mb-10"}
                                        style={{
                                            width: "25%",
                                            minWidth: "200px"
                                        }}
                                    />
                                ))
                                .toList()}
                        </div>
                    </Card>
                </Col>
                <Col span={6} className={"p-5"}>
                    <Card>
                        <Row>
                            <Col span={24}>
                                <Statistic
                                    title={"Minimum Vintage(in Months)"}
                                    value={this.state.minimumVintage}
                                    className={"mb-10"}
                                />
                            </Col>
                            <Col span={24}>
                                <Slider
                                    min={3}
                                    max={12}
                                    onAfterChange={this.onFilterChange.bind(
                                        null,
                                        "minimumVintage"
                                    )}
                                    defaultValue={this.state.minimumVintage}
                                    step={1}
                                    // tooltipVisible={true}
                                />
                            </Col>
                            <Col span={24}>
                                <Statistic
                                    title={"Minimum Limit(in INR)"}
                                    value={this.state.minimumLimit}
                                    className={"mb-10"}
                                />
                            </Col>
                            <Col span={24}>
                                <Slider
                                    min={
                                        50000
                                    }
                                    max={
                                        1000000
                                    }
                                    onAfterChange={this.onFilterChange.bind(
                                        null,
                                        "minimumLimit"
                                    )}
                                    defaultValue={this.state.minimumLimit}
                                    step={50000}
                                    // tooltipVisible={true}
                                />
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span={24} className={"p-5"}>
                    <Table
                        title={"Ledger Analysis"}
                        columns={LEDGER_ANALYSIS_COLS}
                        checkedCols={[]}
                        // data={this.state.analysis
                        //     .get("list")
                        //     .filter(_ =>
                        //         this.state.analysis
                        //             .get(this.state.currentPage)
                        //             .includes(_.id)
                        //     )
                        //     .toList()}
                        data={this.state.analysis.get(this.state.currentPage)}
                        // keyFilter={"id"}
                        showTopSection={false}
                        showBulkDropdown={false}
                        bordered={true}
                        // bulkActionDropdown={this.BulkDropdown}
                        showCsvBtn={false}
                        showAssetsBtn={false}
                        showTitle={false}
                        fixedColsLeft={["date_appointment", "ledger_name"]}
                        loading={this.state.loading}
                        size={"small"}
                        editable={false}
                        showFooter={true}
                        pagination={{
                            current: Number(this.state.currentPage),
                            showSizeChanger: true,
                            pageSizeOptions: [
                                "10",
                                "20",
                                "30",
                                "50",
                                "100",
                                "500"
                            ],
                            pageSize: Number(this.state.pageSize),
                            position: "bottom",
                            total: this.state.count,
                            onChange: (page, pageSize) =>
                                this.onPageChange(page, pageSize),
                            onShowSizeChange: this.onPageChange
                        }}
                    />
                </Col>
            </Row>
        );
    }
}

LedgerAnalysis.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object
};

export default LedgerAnalysis;
